export default {
  methods: {
    setupPhoneInput() {
      const $modal = $('#new-client-modal,#edit-client-modal');

      if ($modal.length) {
        ClientUtils.setup_phone_input($modal);
      }
    },
  },
  mounted() {
    AjaxDialog.registerHook('setup', 'newClientDialog', () => this.setupPhoneInput());
    AjaxDialog.registerHook('setup', 'updateClientDialog', () => this.setupPhoneInput());
    AjaxDialog.registerHook('response', 'updateClientDialog', () => this.setupPhoneInput());
  },
};
